import useEditAdminUser from "../hooks/useEditAdminUser";
import useUserStore from "../store/userStore";

const AdminSetAdmin = ({
  userId,
  isAdmin,
}: {
  userId: number | undefined;
  isAdmin: boolean;
}) => {
  const token = useUserStore((state) => state.token);
  const { mutate, error, isSuccess, isPending } = useEditAdminUser();

  const submit = () => {
    if (!userId) return;
    mutate({ token: token, userId: userId!.toString(), adminValue: !isAdmin });
  };

  return (
    <>
      {isSuccess && <div>Admin permission updated successfully</div>}
      {error && <div>Error: {error.message}</div>}
      <button
        className="btn btn-success"
        onClick={submit}
        disabled={!userId || isPending}
      >
        {isPending ? "Updating..." : (isAdmin ? "Set as User" : "Set as Admin")}
      </button>
    </>
  );
};

export default AdminSetAdmin;
